const lightColors = [
  'bg-red-300',
  'bg-orange-300',
  'bg-amber-300',
  'bg-yellow-300',
  'bg-lime-300',
  'bg-green-300',
  'bg-teal-300',
  'bg-cyan-300',
  'bg-sky-300',
  'bg-blue-300',
  'bg-indigo-300',
  'bg-violet-300',
  'bg-purple-300',
  'bg-fuchsia-300',
  'bg-pink-300',
  'bg-rose-300'
]

const darkColors = [
  'bg-red-700',
  'bg-orange-700',
  'bg-amber-700',
  'bg-yellow-700',
  'bg-lime-700',
  'bg-green-700',
  'bg-teal-700',
  'bg-cyan-700',
  'bg-sky-700',
  'bg-blue-700',
  'bg-indigo-700',
  'bg-violet-700',
  'bg-purple-700',
  'bg-fuchsia-700',
  'bg-pink-700',
  'bg-rose-700'
]

export const stringToColor = (str: string, isDark?: boolean) => {
  let out = 0

  for (let i = 0; i < str.length; i++) {
    out += str.toLowerCase().charCodeAt(i) - 97 + 1
  }

  const colors = isDark ? darkColors : lightColors

  out %= colors.length

  return {
    fg: isDark ? 'text-slate-300' : 'text-zinc-600',
    bg: colors[out]
  }
}
